import React, { Component } from 'react';
import TitleWrapper from 'components/organisms/home/TitleWrapper';
import Welcome from 'components/organisms/home/Welcome';

class GlossaryTitle extends Component {
    render() {
        const welcomeMessage = 'Glossary';
        return (
            <TitleWrapper admin={this.props.admin}>
                <Welcome>{ welcomeMessage }</Welcome>
            </TitleWrapper>

        );
    }
}

export default GlossaryTitle;



// WEBPACK FOOTER //
// ./src/components/molecules/GlossaryTitle.js